/* CENTRO · Motor de carrito compartido RenovaInfinity — assets/centro-cart.js
   v2 · 2026-09-14 (blindaje tras el incidente del 12-sep: 429 "Too Many Requests" en /cart.js dejaba el carrito mudo
   y los CTAs caían al permalink → checkout directo).
   Interfaz pública (la usan los buy boxes y el cajón snippets/centro-cart-drawer):
     window.CentroCart = {
       add(lines, opts)     → Promise<cart>   lines: [{id, quantity, properties?}]  opts: {gift:{id,quantity}, open:true, fallback:true}
       setBundle(spec)      → Promise<cart>   spec: {lines:[...], gift | gifts, open:true}  (reemplaza líneas previas de esos productos y sus regalos)
       change(key, qty)     → Promise<cart>   cambia cantidad de una línea (0 = quitar)
       refresh()            → Promise<cart>   lee /cart.js (una sola lectura en vuelo) y aplica la regla anti-abuso de regalos
       open(fresh) / close()
       req(url, body)       → Promise<json>   fetch al Ajax API con timeout, reintentos (429/5xx/red/JSON roto) y error normalizado
       ultimo()             → último carrito conocido (arranca con {{ cart | json }} del snippet: CERO peticiones al cargar)
       fallbackUrl(items)   → URL clásica /cart/add?items[..]&return_to=/cart (nunca checkout)
     }
   Eventos en document: 'centro:cart:updated' (detail = cart) · 'centro:cart:open' (detail.fresh) · 'centro:cart:close' ·
                        'centro:cart:error' (detail = {mensaje, error, contexto}).
   Blindaje global (sin tocar las páginas):
     · Clic en cualquier a[href*="/cart/VAR:QTY"] o [data-bundle] (captura en window, antes que los scripts de cada página) →
       setBundle + cajón; si el Ajax API falla tras reintentar → location = /cart/add?…&return_to=/cart (página del carrito, NUNCA checkout).
     · Submit de cualquier form[action*="/cart/add"] (plantillas Shrine, quick-add) → add + cajón; si falla → envío nativo del formulario.
     · Nunca se queda un botón "cargando": is-busy/aria-busy se limpian en finally y con un tope de 15 s.
   Reglas de regalos (promos sin SKU nuevo, ver cro-shopify/promos-sin-sku.json):
     jabón corporal ×3/×5 → 1 exfoliante de cuerpo (variante Regalo) · shampoo anticaspa ×2 → 1 anticaída · ×3 → 2 anticaída
   Solo ES5 (sin arrow functions, ni optional chaining, ni template strings) para Safari iOS viejos. */
(function () {
  'use strict';
  if (window.CentroCart && !window.CentroCart._fallback && window.CentroCart._v >= 2) return;

  // ---------- mapa de reglas: producto calificante → regalo → cantidad mínima ----------
  var REGLAS = [
    { nombre: 'jabon-exfoliante', calificante: { product_id: 8233818226828, variant_id: 44377341493388 },
      regalo: { product_id: 8390881312908, variant_id: 57201836556428 }, tiers: [{ min: 3, regalo: 1 }, { min: 5, regalo: 1 }] },
    { nombre: 'anticaspa-anticaida', calificante: { product_id: 8202560929932, variant_id: 44262157385868 },
      regalo: { product_id: 7946278273164, variant_id: 57201838358668 }, tiers: [{ min: 2, regalo: 1 }, { min: 3, regalo: 2 }] }
  ];
  var VARIANTES_REGALO = {};
  REGLAS.forEach(function (r) { VARIANTES_REGALO[r.regalo.variant_id] = r; });
  var PROP_REGALO = { _centro_regalo: '1' };
  var TIENE_BUBBLE = !!document.getElementById('cart-icon-bubble');
  var TOPE_BUSY_MS = 15000;

  // ---------- utilidades ----------
  function esperar(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function noop() {}
  function esRegalo(item) {
    var p = item.properties || {};
    return String(p._centro_regalo || '') === '1' || !!VARIANTES_REGALO[item.variant_id];
  }
  function normLinea(l) {
    var o = { id: parseInt(l.id || l.variant_id, 10), quantity: parseInt(l.quantity, 10) || 1 };
    if (l.properties) o.properties = l.properties;
    if (l.selling_plan) o.selling_plan = l.selling_plan;
    return o;
  }
  function lineaRegalo(g) {
    var o = normLinea(g);
    o.properties = Object.assign({}, o.properties || {}, PROP_REGALO);
    return o;
  }
  function regalosDe(spec) {
    var gs = [];
    if (spec && spec.gift) gs.push(spec.gift);
    if (spec && spec.gifts) gs = gs.concat(spec.gifts);
    return gs.map(lineaRegalo);
  }
  // líneas de un spec; si una línea normal es una variante Regalo del mapa (permalinks), pasa a regalo con su propiedad
  function itemsDe(spec) {
    var lines = [], regalos = regalosDe(spec);
    (spec.lines || spec.items || []).map(normLinea).forEach(function (l) {
      if (VARIANTES_REGALO[l.id] && !(l.properties && l.properties._centro_regalo)) regalos.push(lineaRegalo(l)); else lines.push(l);
    });
    return { lines: lines, regalos: regalos, todos: lines.concat(regalos) };
  }

  // ---------- red: fetch con timeout, reintentos y error normalizado ----------
  var REINTENTOS = [700, 1500, 3000];
  function req(url, body, intento) {
    intento = intento || 0;
    var opts = { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' };
    if (body !== undefined) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    var ctrl = window.AbortController ? new AbortController() : null, timer = null;
    if (ctrl) { opts.signal = ctrl.signal; timer = setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 12000); }
    return fetch(url, opts).then(function (r) {
      clearTimeout(timer);
      return r.text().then(function (txt) {
        var d = null;
        try { d = JSON.parse(txt); } catch (e) {}
        if (r.ok && d && typeof d === 'object') return d;
        var err = new Error((d && (d.description || d.message)) || ('HTTP ' + r.status));
        err.status = r.status; err.data = d;
        err.retryAfter = parseFloat(r.headers && r.headers.get && r.headers.get('Retry-After')) || 0;
        err.reintentable = r.status === 429 || r.status >= 500 || r.status === 0 || (r.ok && !d);
        throw err;
      });
    }, function (e) {
      clearTimeout(timer);
      var err = new Error('Sin conexión'); err.status = 0; err.reintentable = true; err.causa = e; throw err;
    }).catch(function (err) {
      if (err && err.reintentable && intento < REINTENTOS.length) {
        var ms = Math.max(REINTENTOS[intento], Math.min((err.retryAfter || 0) * 1000, 6000));
        return esperar(ms).then(function () { return req(url, body, intento + 1); });
      }
      throw err;
    });
  }
  function mensajeDe(err) {
    if (err && err.status === 422 && err.data && err.data.description) return err.data.description;   // sin stock, etc.
    if (err && err.status === 429) return 'La tienda tiene muchas visitas ahora mismo. Intenta de nuevo en unos segundos.';
    if (err && err.status === 0) return 'Sin conexión. Revisa tu internet e intenta de nuevo.';
    return 'No pudimos actualizar tu carrito. Intenta de nuevo.';
  }
  // una sola lectura de /cart.js en vuelo (el cajón y el motor comparten la misma promesa)
  var leyendo = null;
  function leerCarrito() {
    if (leyendo) return leyendo;
    leyendo = req('/cart.js').then(function (c) { leyendo = null; return c; }, function (e) { leyendo = null; throw e; });
    return leyendo;
  }
  // mutaciones en serie (evita carreras add/update/change simultáneos y peticiones duplicadas)
  var cola = Promise.resolve();
  function enCola(fn) {
    var p = cola.then(fn, fn);
    cola = p.then(noop, noop);
    return p;
  }
  function conSecciones(body) { if (TIENE_BUBBLE) body.sections = 'cart-icon-bubble'; return body; }
  function pintarBubble(d) {
    if (!d || !d.sections || !d.sections['cart-icon-bubble']) return;
    var ib = document.getElementById('cart-icon-bubble');
    if (!ib) return;
    var tmp = document.createElement('div'); tmp.innerHTML = d.sections['cart-icon-bubble'];
    var inner = tmp.querySelector('.shopify-section') || tmp;
    ib.innerHTML = inner.innerHTML;
  }

  // ---------- estado y eventos ----------
  var ultimo = null;
  function emitir(cart) {
    if (!cart || !cart.items) return cart;
    ultimo = cart;
    try { cart._centro_origen = 'centro-cart'; } catch (e) {}
    document.dispatchEvent(new CustomEvent('centro:cart:updated', { detail: cart }));
    return cart;
  }
  function avisarError(err, contexto) {
    try { console.warn('[CentroCart]', contexto, err && (err.status || ''), err && err.message); } catch (e) {}
    document.dispatchEvent(new CustomEvent('centro:cart:error', { detail: { mensaje: mensajeDe(err), error: err, contexto: contexto } }));
  }
  function inicial() {
    var el = document.getElementById('centro-cart-inicial');
    if (!el) return null;
    try { var c = JSON.parse(el.textContent || ''); return c && c.items ? c : null; } catch (e) { return null; }
  }

  // ---------- regla anti-abuso: regalos huérfanos ----------
  function regalosPermitidos(cart, regla) {
    var n = 0;
    cart.items.forEach(function (it) {
      if (!esRegalo(it) && it.product_id === regla.calificante.product_id) n += it.quantity;
    });
    var permitido = 0;
    regla.tiers.forEach(function (t) { if (n >= t.min) permitido = Math.max(permitido, t.regalo); });
    return permitido;
  }
  function limpiarRegalos(cart) {
    var cambios = {}, hay = false, cupo = {};
    REGLAS.forEach(function (r) { cupo[r.regalo.variant_id] = regalosPermitidos(cart, r); });
    cart.items.forEach(function (it) {
      if (!esRegalo(it)) return;
      var regla = VARIANTES_REGALO[it.variant_id];
      if (!regla) { cambios[it.key] = 0; hay = true; return; }           // regalo desconocido → fuera
      var permitido = cupo[it.variant_id];
      var q = Math.min(it.quantity, permitido);
      cupo[it.variant_id] = permitido - q;
      if (q !== it.quantity) { cambios[it.key] = q; hay = true; }
    });
    return hay ? cambios : null;
  }
  var aplicando = false;
  function aplicarReglas(cart) {
    var cambios = limpiarRegalos(cart);
    if (!cambios || aplicando) return Promise.resolve(cart);
    aplicando = true;
    return req('/cart/update.js', conSecciones({ updates: cambios }))
      .then(function (c) { aplicando = false; pintarBubble(c); return c; }, function () { aplicando = false; return cart; });
  }

  // ---------- respaldo clásico (sin Ajax): página /cart, nunca checkout ----------
  function fallbackUrl(items) {
    var q = [];
    items.forEach(function (it, i) {
      q.push('items[' + i + '][id]=' + it.id + '&items[' + i + '][quantity]=' + it.quantity);
      if (it.properties) Object.keys(it.properties).forEach(function (k) {
        q.push('items[' + i + '][properties][' + encodeURIComponent(k) + ']=' + encodeURIComponent(it.properties[k]));
      });
    });
    return '/cart/add?' + q.join('&') + '&return_to=%2Fcart';
  }
  function hayCajon() { return !!(document.getElementById('centro-cd') || window.CentroCartDrawer); }
  function open(fresh) {
    document.dispatchEvent(new CustomEvent('centro:cart:open', { detail: { fresh: fresh === true } }));
    if (!hayCajon()) location.href = '/cart';   // sin cajón en la página: el flujo nunca se queda a ciegas
  }
  function close() {
    document.dispatchEvent(new CustomEvent('centro:cart:close'));
    if (window.CentroCartDrawer && window.CentroCartDrawer.close) window.CentroCartDrawer.close();
  }
  // tras un fallo: fallo de red/límite → vía clásica; fallo de negocio (422 sin stock) → mensaje visible
  function fallar(err, contexto, items, opts) {
    avisarError(err, contexto);
    var fb = !opts || opts.fallback !== false;
    if (fb && err && (err.reintentable || err.status === 0) && items && items.length) {
      location.href = (opts && opts.fallbackUrl) || fallbackUrl(items);
      return new Promise(noop);   // la navegación se lleva la página
    }
    if (hayCajon()) open(true); else if (fb) alert(mensajeDe(err));
    throw err;
  }

  // ---------- API ----------
  function refresh() {
    return leerCarrito().then(aplicarReglas).then(emitir);
  }
  function terminar(items, opts, contexto) {
    // el add/update ya se aplicó: si /cart.js falla al refrescar NO se navega a ciegas, se abre el cajón con el último estado
    return refresh().then(function (c) {
      if (!opts || opts.open !== false) open(true);
      return c;
    }, function (err) {
      avisarError(err, contexto + ':refresh');
      if (hayCajon() && ultimo) { open(true); return ultimo; }
      location.href = '/cart';
      return new Promise(noop);
    });
  }
  function add(lines, opts) {
    opts = opts || {};
    var it = itemsDe({ lines: Array.isArray(lines) ? lines : [lines], gift: opts.gift, gifts: opts.gifts });
    return enCola(function () { return req('/cart/add.js', conSecciones({ items: it.todos })); })
      .then(function (d) { pintarBubble(d); return terminar(it.todos, opts, 'add'); },
            function (err) { return fallar(err, 'add', it.todos, opts); });
  }
  function setBundle(spec) {
    spec = spec || {};
    var it = itemsDe(spec);
    var ids = {}, productos = {};
    it.todos.forEach(function (l) { ids[l.id] = true; });
    REGLAS.forEach(function (r) { if (ids[r.calificante.variant_id]) { productos[r.calificante.product_id] = true; ids[r.regalo.variant_id] = true; } });
    return enCola(function () {
      return leerCarrito().then(function (cart) {
        var updates = {};
        cart.items.forEach(function (c) { if (ids[c.variant_id] || productos[c.product_id]) updates[c.key] = 0; });   // fuera líneas previas del bundle y sus regalos
        return Object.keys(updates).length ? req('/cart/update.js', { updates: updates }) : cart;
      }, function () { return null; })   // si no se pudo leer, se agrega igual (mejor sumar que perder la venta)
      .then(function () { return req('/cart/add.js', conSecciones({ items: it.todos })); });
    }).then(function (d) { pintarBubble(d); return terminar(it.todos, spec, 'setBundle'); },
            function (err) { return fallar(err, 'setBundle', it.todos, spec); });
  }
  function change(key, qty) {
    return enCola(function () { return req('/cart/change.js', conSecciones({ id: key, quantity: qty })); })
      .then(function (c) { pintarBubble(c); return aplicarReglas(c); }).then(emitir)
      .catch(function (err) { avisarError(err, 'change'); throw err; });
  }

  // ---------- busy sin quedarse trabado ----------
  function busy(el, on) {
    if (!el) return;
    if (on) {
      el.classList.add('is-busy'); el.setAttribute('aria-busy', 'true');
      clearTimeout(el.__centroBusyT);
      el.__centroBusyT = setTimeout(function () { busy(el, false); }, TOPE_BUSY_MS);
    } else {
      clearTimeout(el.__centroBusyT);
      el.classList.remove('is-busy'); el.removeAttribute('aria-busy');
    }
  }
  var css = document.createElement('style');
  css.textContent = '[aria-busy="true"]{opacity:.65!important;pointer-events:none!important;cursor:progress!important}';
  (document.head || document.documentElement).appendChild(css);

  // ---------- interceptor global de CTAs: permalinks /cart/VAR:QTY[,VAR:QTY] y [data-bundle] ----------
  var RE_PERMALINK = /\/cart\/(\d+:\d+(?:,\d+:\d+)*)(?:[\/?#]|$)/;
  function specDe(el) {
    var spec = null;
    var href = (el.getAttribute && el.getAttribute('href')) || '';
    var m = href.match(RE_PERMALINK);
    if (m) spec = { lines: m[1].split(',').map(function (p) { var q = p.split(':'); return { id: parseInt(q[0], 10), quantity: parseInt(q[1], 10) || 1 }; }) };
    var db = el.getAttribute && el.getAttribute('data-bundle');
    if (db) { try { var b = JSON.parse(db); if (b && (b.lines || b.items)) spec = Object.assign(spec || {}, b); } catch (e) {} }
    return spec;
  }
  function alClic(e) {
    if (e.button && e.button !== 0) return;
    var t = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
    if (!t || !t.closest) return;
    var el = t.closest('a[href*="/cart/"],[data-bundle]');
    if (!el || el.closest('#centro-cd')) return;
    var spec = specDe(el);
    if (!spec) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    if (el.getAttribute('aria-busy') === 'true') return;   // doble clic
    spec.open = true;
    busy(el, true);
    setBundle(spec).then(function () { busy(el, false); }, function () { busy(el, false); });
  }
  window.addEventListener('click', alClic, true);

  // ---------- toma de formularios /cart/add (plantillas Shrine, quick-add, sticky) ----------
  function itemsDeForm(f) {
    var item = { quantity: 1 }, props = null;
    // f.elements incluye los campos asociados con el atributo form="…" (Shrine pone los radios de cantidad FUERA del <form>)
    var campos = f.elements ? Array.prototype.slice.call(f.elements) : Array.prototype.slice.call(f.querySelectorAll('input,select,textarea'));
    campos.forEach(function (i) {
      if (!i.name || i.disabled) return;
      if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
      var pm = i.name.match(/^properties\[(.+)\]$/);
      if (pm) { props = props || {}; props[pm[1]] = i.value; return; }
      if (i.name === 'id') item.id = parseInt(i.value, 10);
      else if (i.name === 'quantity') item.quantity = parseInt(i.value, 10) || 1;
      else if (i.name === 'selling_plan' && i.value) item.selling_plan = i.value;
    });
    if (props) item.properties = props;
    return item.id ? [item] : [];
  }
  function alSubmit(e) {
    var f = e.target;
    if (!f || f.nodeName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (!/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(action) || f.closest('#centro-cd')) return;
    if (f.getAttribute('data-centro-nativo') === '1') return;   // reenvío clásico de respaldo
    var items = itemsDeForm(f);
    if (!items.length) return;                                   // no lo entendemos: que siga el flujo del tema
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    var btn = e.submitter || f.querySelector('[type="submit"]');
    if (f.getAttribute('aria-busy') === 'true') return;
    f.setAttribute('aria-busy', 'true'); busy(btn, true);
    var fin = function () { f.removeAttribute('aria-busy'); busy(btn, false); };
    enCola(function () { return req('/cart/add.js', conSecciones({ items: items })); })
      .then(function (d) { pintarBubble(d); return terminar(items, { open: true }, 'form'); })
      .then(fin, function (err) {
        fin(); avisarError(err, 'form');
        if (err && (err.reintentable || err.status === 0)) { f.setAttribute('data-centro-nativo', '1'); try { f.submit(); } catch (e2) { location.href = fallbackUrl(items); } }
        else if (hayCajon()) open(true); else alert(mensajeDe(err));
      });
  }
  document.addEventListener('submit', alSubmit, true);

  window.CentroCart = {
    _v: 2, add: add, setBundle: setBundle, change: change, refresh: refresh, open: open, close: close, req: req,
    fallbackUrl: fallbackUrl, mensajeDe: mensajeDe, reglas: REGLAS, esRegalo: esRegalo, ultimo: function () { return ultimo; }
  };

  // cambios hechos por otros módulos (cajón, tema): re-aplicar la regla de regalos sin entrar en bucle
  document.addEventListener('centro:cart:updated', function (e) {
    var c = e.detail;
    if (!c || !c.items || c._centro_origen === 'centro-cart') return;
    if (limpiarRegalos(c)) aplicarReglas(c).then(emitir);
  });
  // arranque: estado inicial embebido por Liquid (cero peticiones); solo si no existe se lee /cart.js
  function arrancar() {
    var c0 = inicial();
    if (c0) { emitir(c0); if (limpiarRegalos(c0)) aplicarReglas(c0).then(emitir, noop); }
    else refresh().then(noop, function (err) { avisarError(err, 'inicio'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  // volver con el botón atrás (bfcache) puede traer un carrito viejo: releer
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().then(noop, noop); });
})();
